// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__rf25u"};